// index
export const SET_USER_DATA = "SET_USER_DATA";
export const LOADING_USER_DATA = "LOADING_USER_DATA";
export const UPDATE_USER_DATA_LOADING = "UPDATE_USER_DATA_LOADING";
export const USER_UPDATE_DATA = "USER_UPDATE_DATA";
export const MOBILE_CHANGE_SHOW_MENU = "MOBILE_CHANGE_SHOW_MENU";
export const SET_USER_TARIFF_LOADING = "SET_USER_TARIFF_LOADING";
export const SET_USER_TARIFF = "SET_USER_TARIFF";
export const SET_PREV_ROUTE = "SET_PREV_ROUTE";
export const SET_PROFILE_ROUTES = "SET_PROFILE_ROUTES";
export const REMOVE_PROFILE_ROUTE = "REMOVE_PROFILE_ROUTE";

// contacts
export const LINK_ACCOUNT_LOADING = "LINK_ACCOUNT_LOADING";
export const SEND_REQUEST_CHANGE_PHONE_LOADING = "SEND_REQUEST_CHANGE_PHONE_LOADING";
export const SEND_REQUEST_CHANGE_EMAIL_LOADING = "SEND_REQUEST_CHANGE_EMAIL_LOADING";
export const UNLINK_ACCOUNT_LOADING = "UNLINK_ACCOUNT_LOADING";
export const USER_REMOVE_SOCIAL_PROVIDER = "USER_REMOVE_SOCIAL_PROVIDER";
export const POPUP_USER_CONTACTS_CHANGE = "POPUP_USER_CONTACTS_CHANGE";

// password
export const PASSWORD_UPDATE_LOADING = "PASSWORD_UPDATE_LOADING";

// setting
export const SETTING_GET_LANGUAGE_INTERFACE_LOADING =
    "SETTING_GET_LANGUAGE_INTERFACE_LOADING";
export const SETTING_SET_LANGUAGE_INTERFACE = "SETTING_SET_LANGUAGE_INTERFACE";
export const SETTING_GET_FORMATS_DATE_LOADING = "SETTING_GET_FORMATS_DATE_LOADING";
export const SETTING_SET_FORMATS_DATE = "SETTING_SET_FORMATS_DATE";
export const SETTING_UPDATE_LOADING = "SETTING_UPDATE_LOADING";
export const SETTING_GET_BASIC_COUNTRIES_LOADING = "SETTING_GET_BASIC_COUNTRIES_LOADING";
export const SETTING_SET_BASIC_COUNTRIES = "SETTING_SET_BASIC_COUNTRIES";

// main-info
export const UPDATE_AVATAR_LOADING = "UPDATE_AVATAR_LOADING";
export const INFO_UPDATE_LOADING = "INFO_UPDATE_LOADING";
export const FRESH_USER_PERSONA_DATA = "FRESH_USER_PERSONA_DATA";
export const SET_USER_SKILLS = "SET_USER_SKILLS";
export const SET_USER_SKILLS_LOADING = "SET_USER_SKILLS_LOADING";

// tariffs
export const DELETE_USER_TARIFF_LOADING = "DELETE_USER_TARIFF_LOADING";
export const REMOVE_USER_TARIFF_IN_LIST = "REMOVE_USER_TARIFF_IN_LIST";
export const SET_USER_FREE_ACCESS_LOADING = "SET_USER_FREE_ACCESS_LOADING";
export const SET_USER_FREE_ACCESS = "SET_USER_FREE_ACCESS";

// payments
export const SET_NEW_PAYMENTS_METHOD_LOADING = "SET_NEW_PAYMENTS_METHOD_LOADING";
export const GET_CARDS_LIST_LOADING = "GET_CARDS_LIST_LOADING";
export const SET_CARDS_LIST = "SET_CARDS_LIST";
export const SET_DEFAULT_PAYMENT_METHOD_LOADING = "SET_DEFAULT_PAYMENT_METHOD_LOADING";
export const DELETE_CARD_LOADING = "DELETE_CARD_LOADING";
export const CHANGE_POPUP_DELETE_CARD = "CHANGE_POPUP_DELETE_CARD";
export const SET_PROVIDER = "SET_PROVIDER";
export const CHANGE_OPEN_NOTIFICATION = "CHANGE_OPEN_NOTIFICATION";
export const CONTINUE_PAY = "CONTINUE_PAY";

// payments-history
export const GET_LIST_LOADING = "GET_LIST_LOADING";
export const SET_LIST = "SET_LIST";
export const CHANGE_SKIP = "CHANGE_SKIP";
export const SET_LIST_LENGTH = "SET_LIST_LENGTH";
export const CHANGE_DATE_TO = "CHANGE_DATE_TO";
export const CHANGE_DATE_FROM = "CHANGE_DATE_FROM";
export const CHANGE_POPUP_CANCEL_SUBSCRIPTION = "CHANGE_POPUP_CANCEL_SUBSCRIPTION";
export const CHANGE_POPUP_UPDATE_SUBSCRIPTION = "CHANGE_POPUP_UPDATE_SUBSCRIPTION";

// homework
export const SET_USER_HOMEWORK = "SET_USER_HOMEWORK";
export const SET_USER_HOMEWORK_LOADING = "SET_USER_HOMEWORK_LOADING";
export const CHANGE_HOMEWORK_FILTER_COURSE = "CHANGE_HOMEWORK_FILTER_COURSE";
export const CHANGE_HOMEWORK_FILTER_STATUS = "CHANGE_HOMEWORK_FILTER_STATUS";
export const CLEAR_HOMEWORK_FILTERS = "CLEAR_HOMEWORK_FILTERS";
export const SET_STATUS_LIST = "SET_STATUS_LIST";
export const GET_STATUS_LIST_LOADING = "GET_STATUS_LIST_LOADING";
export const SET_STATUS_LIST_LENGTH = "SET_STATUS_LIST_LENGTH";
